export default __webpack_public_path__ + "media/images/btn-export_v2-3a70f4b6564ff9b3c00c0a7f4422c126.png";